<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="modal-header">
                <span class="modal-header-title">{{ 'DIALOG.TAG_LIST.MARK_LIST' | translate }}</span>
                <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                    <span aria-hidden="true"><i class="bi bi-x-lg" style="font-size: 16px;"></i></span>
                </button> -->
                <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                    <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                    [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                </button>
            </div>

            <div class="buttons">

                <div class="first-block">
                    
                    <button type="button" *ngIf="countSelectedFiles > 0" class="btn btn-primary btn-sm btn-custom-actions" (click)="sendData()" [disabled]="!checkedCheckBox()">
                        Применить к товару ({{countSelectedFiles}})
                    </button>
                    
                    <button type="button" *ngIf="countSelectedFiles > 0" class="btn btn-delete btn-sm btn-custom-actions" [disabled]="!checkedCheckBox()" (click)="deleteSelected()">
                        <!-- <i class="bi bi bi-trash"></i> -->
                         {{ 'DELETE' | translate }}
                    </button>
                </div>

                <button type="button" class="btn btn-primary btn-sm btn-add" (click)="onAction()">
                                <!-- <i class="bi bi-plus-circle"></i> -->
                     <svg-icon src="/assets/images/icons/add.svg" [stretch]="true"
                     [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                      <div>{{ 'ADD' | translate }}</div>

                </button>
               
                <!-- <button type="button" class="btn btn-primary btn-sm btn-custom" (click)="onAction()">
                    <svg-icon src="/assets/images/icons/add.svg" [stretch]="true"
                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                    {{ 'ADD' | translate }}
                </button> -->
            </div>

            <div class="modal-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_tag_all"
                                        id="select_tag_all" [checked]="checkedCheckBox()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_tag_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="visual">Иконка и название</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="tagsList && tagsList.length > 0">
                        <tr *ngFor="let tag of tagsList; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_tag_{{ i }}"
                                        id="select_tag_{{ i }}" [checked]="tag.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_tag_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="visual">
                                <div class="tag-box">
                                    <div *ngIf="tag.graphics_visible" [ngStyle]="getTagStyle(tag.tag_size_detail)">
                                        <div [innerHTML]="tag.tagHtml" [color]="tag.color"></div>
                                    </div>
                                    <div *ngIf="tag.text_visible" [ngStyle]="{'color': tag.font_color}">
                                        {{tag.name}}
                                    </div>
                                </div>
                            </td>
                            <td class="action">
                                <div class="action-buttons">
                                    <button type="button" class="btn" (click)="onAction(tag.id)"
                                        placement="top" tooltipClass="clue-name" [closeDelay]="300" ngbTooltip="{{ 'EDIT' | translate }}" [disabled]="!tag.org_id">
                                        <svg-icon class="" src="/assets/images/icons/edit.svg" [svgStyle]="{'width.px':18, 'height.px':18}" [stretch]="true"></svg-icon>
                                    </button>
                                    <button type="button" class="btn" (click)="onConfirm([tag.id])"
                                        placement="top" tooltipClass="clue-name" [closeDelay]="300" ngbTooltip="{{ 'DELETE' | translate }}" [disabled]="!tag.org_id">
                                        <svg-icon src="/assets/images/icons/trash-can.svg" [svgStyle]="{'width.px':18, 'height.px':18}" [stretch]="true"></svg-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!tagsList || tagsList.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="5">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="5">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>